import React from 'react';

class FormGroup extends React.Component {
    render() {
        return (
            <div className={ 'form-group' } >
                <label>{this.props.label}</label>
                <input className={ 'form-control' } name={this.props.name} value={ this.props.value } onChange={ this.props.onChange }/>
            </div>
        )
    }
}

export default FormGroup;